const imageScaler = (file: string, fileType: string, boxWidth: number, boxHeight: number): Promise<string> => {
    return new Promise((resolve, reject) => {
        if (!file) {
            reject("No file provided");
            return;
        }

        const img = new Image();
        img.onload = (): void => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (!ctx) {
                reject("Canvas context not available");
                return;
            }

            const MAX_WIDTH = boxWidth;
            const MAX_HEIGHT = boxHeight;
            let width = img.width;
            let height = img.height;
            console.log(width, height)
            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }

            canvas.width = boxWidth;
            canvas.height = boxHeight;
            ctx.drawImage(img, 0, 0, boxWidth, boxHeight);

            canvas.toBlob((blob) => {
                if (blob) {
                    const blobUrl = URL.createObjectURL(blob);
                    resolve(blobUrl);
                }
                resolve("")

            }, fileType); // Change to desired format
        };

        img.onerror = (): void => {
            reject("Error loading image");
        };

        img.src = file;
    });
};

export { imageScaler };
